/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/ongoing/perception-outside-consciousness.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/ongoing/perception-outside-consciousness.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/perception-outside-consciousness.mdx';

const metadata = {
  slug: "perception-outside-consciousness",
  title: "Perception Outside Consciousness",
  author: "Christian Battaglia",
  description: "My first ongoing \"down the whole\" post — cautiously voicing extremely hard questions about reality, consciousness, religion, and science. From Aristotle's essence to Laplace's demon, structured as an ever-growing research document.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  headerImage: "/assets-cdbattaglia/media/blog-posts/2019-01-07_perception-outside-consciousness/valentin-lacoste-727397-unsplash.webp",
  date: "2019-01-04T00:00:00.000Z",
  
  readTime: "12 min read",
  tags: ["philosophy","neuroscience","consciousness","Aristotle","Kant","Laplace","Catholicism","mathematics","physics"],
};

export const Route = createFileRoute('/blog/posts/perception-outside-consciousness')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/perception-outside-consciousness',
    image: '/og/blog/perception-outside-consciousness.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
